import { Validator } from "fluentvalidation-ts";

type Building = {
  username: string;
  password:string;
};

class BuildingValidator extends Validator<Building> {
  constructor() {
    super();

    this.ruleFor("username")
      .notEmpty()
      .notNull()
      .withMessage("Perfavore inserisci il tuo username");

    this.ruleFor("password")
      .notEmpty()
      .notNull()
      .withMessage("Perfavore inserisci la password");
      // .matches(new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$'))
      // .withMessage("Password non valida");
  }
}

export default BuildingValidator;
